import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAccessUsersQuery } from "../api/Endpoints/Core/Security/Users";
import { ACCESS_RIGHTS } from "../constants/accessRights";
import { getCurrentUser, hasAccess } from "../helpers/session_helper";

const Navdata = () => {
  const history = useNavigate();
  const location = useLocation();

  const [iscurrentState, setIscurrentState] = useState("Dashboard");
  const shouldFetch = getCurrentUser()
  const { data, refetch } = useGetAccessUsersQuery({}, { skip: !shouldFetch });
  const accessRights = data?.returnData?.map(({
    permissionTypeId,
    allowRead,
    allowWrite,
    allowDelete
  }) => ({
    permissionTypeId,
    allowRead,
    allowWrite,
    allowDelete
  }));

  useEffect(() => {
    refetch();
  }, [location.pathname]);

  useEffect(() => {
    if (accessRights) {
      sessionStorage.setItem("accessRights", JSON.stringify(accessRights));
    }
  }, [accessRights]);

  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);

  const [isDashboard, setIsDashboard] = useState(false);
  const [isNAS, setIsNAS] = useState(false);

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }

    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }

    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "NAS") {
      setIsNAS(false);
    }
  }, [
    history,

    iscurrentState,

    isApps,
    isAuth,
    isPages,
    isDashboard,

    isNAS,
  ]);

  const menuItems = [
    {
      label: "National Academy of Sports",
      isHeader: true,
      color: "#0ab39c"
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-bar-chart-2-fill",
      link: "/",
      click: function (e) {
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "nas-students",
      label: "Students",
      icon: "ri-team-fill",
      link: "/nas/students",
      parentId: "nas",
      permissionTypeId: [
        ACCESS_RIGHTS.NAS_STUDENTS
      ]
    },
    {
      id: "nas-guidancecounselling",
      label: "GCAWS",
      icon: "ri-heart-add-fill",
      link: "/nas/guidanceVisits",
      parentId: "nas",
      permissionTypeId: [
        ACCESS_RIGHTS.NAS_TRANSACTIONS_GUIDANCECOUNSELORVISITS
      ]
    },
    {
      id: "nas-clinicvisits",
      label: "Clinic",
      icon: "ri-stethoscope-line",
      link: "/nas/clinicvisits",
      parentId: "nas",
      permissionTypeId: [
        ACCESS_RIGHTS.NAS_TRANSACTIONS_CLINICVISITS
      ]
    },
    {
      id: "nas-dormvisits",
      label: "Dormitory",
      icon: "ri-building-2-line",
      link: "/nas/dormitory",
      parentId: "nas",
      permissionTypeId: [
        ACCESS_RIGHTS.NAS_TRANSACTIONS_DORMITORYVISITS
      ]
    },
    {
      id: "nas-checkins",
      label: "Check-Ins",
      icon: "ri-map-pin-user-fill",
      link: "/nas/checkins",
      parentId: "nas",
      permissionTypeId: [
        ACCESS_RIGHTS.NAS_TRANSACTIONS_CHECKINS
      ]
    },
    {
      id: "nas-nutrition",
      label: "Nutrition",
      icon: "ri-restaurant-line",
      link: "/nas/nutrition",
      parentId: "nas",
      permissionTypeId: [
      ]
    },
    {
      id: "nas-physical-therapy",
      label: "Physical Therapy",
      icon: "ri-run-line",
      link: "/nas/physical-therapy",
      parentId: "nas",
      permissionTypeId: [
      ]
    },
    {
      id: "nas-settings",
      label: "Settings",
      icon: "ri-settings-2-fill",
      link: "/nas/settings",
      parentId: "nas",
      permissionTypeId: [
        ACCESS_RIGHTS.NAS_STATICDATA_BUILDINGLOCATIONS,
        ACCESS_RIGHTS.NAS_STATICDATA_GUIDANCEVISITTYPES,
        ACCESS_RIGHTS.NAS_STATICDATA_CLINICVISITTYPES,
        ACCESS_RIGHTS.NAS_STATICDATA_CLOCKINDEVICES,
        ACCESS_RIGHTS.NAS_STATICDATA_GRADELEVELS,
        ACCESS_RIGHTS.NAS_STATICDATA_RFIDCARDS,
        ACCESS_RIGHTS.NAS_STATICDATA_ROOMS,
        ACCESS_RIGHTS.NAS_STATICDATA_SPORTS,
      ]
    },
    {
      id: "nas-reports",
      label: "Reports",
      icon: "ri-article-line",
      link: "/nas/reports",
      parentId: "nas",
      permissionTypeId: [
      ]
    },
    {
      label: "Security",
      isHeader: true,
    },
    {
      id: "Users",
      label: "Users",
      icon: "ri-admin-fill",
      link: "/security/users",
      click: function (e) {
        setIscurrentState("Users");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_USERS,
      ]
    },
    {
      id: "Roles",
      label: "Roles",
      icon: "ri-lock-unlock-fill",
      link: "/security/roles",
      click: function (e) {
        setIscurrentState("Roles");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_ROLES,
      ],
    },
    {
      id: "AuditLogs",
      label: "Audit Logs",
      icon: "ri-shield-flash-fill",
      link: "/security/auditLogs",
      click: function (e) {
        setIscurrentState("AuditLogs");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_AUDITLOGS,
      ],
    },
    {
      id: "AccessRequests",
      label: "Access Requests",
      icon: "ri-key-fill",
      link: "/security/accessrequests",
      click: function (e) {
        setIscurrentState("AccessRequests");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER,
      ],
    },
    // {
    //   label: "Application",
    //   isHeader: true,
    // },
    // {
    //   id: "FAQs",
    //   label: "FAQs",
    //   icon: "ri-question-fill",
    //   link: "/socials/faq",
    //   click: function (e) {
    //     setIscurrentState("FAQs");
    //   },
    // },
    // {
    //   id: "PrivacyPolicy",
    //   label: "Privacy Policy",
    //   icon: "ri-git-repository-private-fill",
    //   link: "/socials/privacy-policy",
    //   click: function (e) {
    //     setIscurrentState("PrivacyPolicy");
    //   },
    // },
    // {
    //   id: "TermsCondition",
    //   label: "Terms Condition",
    //   icon: "ri-spam-2-fill",
    //   link: "/socials/terms-conditions",
    //   click: function (e) {
    //     setIscurrentState("TermsCondition");
    //   },
    // },
  ];

  const filterMenu = (items) => {
    return items
      .filter(item => hasAccess(item.permissionTypeId, accessRights))
      .map(item => {
        const newItem = { ...item };

        if (item.subItems) {
          newItem.subItems = filterMenu(item.subItems);
          if (newItem.subItems.length === 0) return null;
        }

        if (item.childItems) {
          newItem.childItems = filterMenu(item.childItems);
          if (newItem.childItems.length === 0) return null;
        }

        return newItem;
      })
      .filter(Boolean);
  };

  return <React.Fragment>{filterMenu(menuItems)}</React.Fragment>;
};
export default Navdata;
